"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.format = exports.prepareUrls = exports.replaceTemplateVars = exports.addBase = void 0;
const lodash_1 = __importDefault(require("lodash"));
/**
 * Maps through urls and adds a prefix.
 *
 * @param {string} url - Url.
 * @param {string} base - Url prefix.
 */
function addBase(url, base) {
    return base + url;
}
exports.addBase = addBase;
/**
 * Iterates through urls and tries to replace template variables if found.
 *
 * @param {string} url - Url potentially with template variables in it.
 * @param {string[]} templateVars - List of template variables.
 */
function replaceTemplateVars(url, templateVars) {
    return lodash_1.default.reduce(templateVars, (str, value, key) => lodash_1.default.replace(str, `%${key}%`, value), url);
}
exports.replaceTemplateVars = replaceTemplateVars;
function prepareUrls(urls, config) {
    return lodash_1.default.mapValues(urls, (item) => {
        if (lodash_1.default.isPlainObject(item)) {
            return prepareUrls(item, config);
        }
        return replaceTemplateVars(addBase(item, lodash_1.default.get(config, 'base', '')), config);
    });
}
exports.prepareUrls = prepareUrls;
/**
 * Formatter which recursively goes through supplied urls.
 *
 * @param {KeyPair} urls - List of urls to format.
 * @param {object} config - Configuration.
 * @returns {object} - Hashmap of formatted urls.
 */
function format(urls, config) {
    const result = lodash_1.default.cloneDeep(urls);
    const processedUrls = (0, lodash_1.default)(config)
        .mapKeys((value, key) => lodash_1.default.toUpper(key))
        .pickBy((value, key) => lodash_1.default.has(urls, key))
        .mapValues((value, key) => prepareUrls(result[key], value))
        .value();
    return lodash_1.default.assign(result, processedUrls);
}
exports.format = format;
exports.default = {
    addBase,
    format,
    prepareUrls,
    replaceTemplateVars,
};
